module.exports = __webpack_public_path__ + "assets/5619409ecf02ec141531367d58ba6223.svg";